module.exports = __webpack_public_path__ + "img/sdc_pic_1.d748de31.jpg";